import { IAppState } from '../../../../../AppModulesWrapper';
import { IRecommendedPackage } from '../types';

export function selectRecommendedPackages(state: IAppState): IRecommendedPackage[] {
  return state.servicePickerWidgetV2.recommendedPackages.packages;
}
